import React, { useEffect, useRef } from 'react';

const Modal: React.FC<{ closeModal: () => void }> = ({ children, closeModal }) => {
  const modalRef = useRef(null);

  const handleClickOutside = (event: any) => {
    const current: any = modalRef.current || '';
    if (modalRef.current && !current.contains(event.target)) {
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <div
      className="fixed absolute--fill flex items-center justify-center pa3 z-max"
      style={{ background: 'rgba(255, 255, 255, 0.98)' }}
    >
      <div
        ref={modalRef}
        className="relative w-100 shadow-1 bg-white br3 w-100"
        style={{ maxWidth: 384 }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
